module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "required": _vm.required,
      "value": _vm.displayValue,
      "hide-details": ""
    },
    on: {
      "focus": _vm.openPicker
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.picker),
      expression: "picker"
    }],
    staticClass: "data-range-picker elevation-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePicker($event)
      }
    }
  }, [_c('div', {
    staticClass: "inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.closePicker($event)
      }
    }
  }, [_c('date-time', {
    attrs: {
      "label": _vm.$t('time.from')
    },
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  }), _vm._v(" "), _c('date-time', {
    attrs: {
      "label": _vm.$t('time.to')
    },
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "flat": "",
      "success": ""
    }
  }, [_vm._v("OK")])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2040c08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateRange.vue
// module id = 1099
// module chunks = 1